<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="用户uid" prop="user">
              <a-input v-model="formInline.uid" placeholder="请输入用户uid">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="7">
            <a-form-model-item label="用户昵称" prop="password">
              <a-input
                v-model="formInline.username"
                placeholder="请输入用户昵称"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="7">
            <a-form-model-item label="手机号码" prop="password">
              <a-input v-model="formInline.phone" placeholder="请输入手机号码">
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <userCheckinRecordContent
          ref="aaa"
          :formInline="formInline"
        ></userCheckinRecordContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import userCheckinRecordContent from "./userCheckinRecordContent.vue";
export default {
  components: {
    userCheckinRecordContent,
  },
  data() {
    return {
      formInline: {
        limit: 10,
        page: 1,
        uid: "",
        phone: "",
        username: "",
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.aaa.query();
    },
    resetForm() {
      this.$refs.aaa.getUserSignin();
      this.formInline = {};
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/userCheckinRecord/userCheckinRecord.vue